import { api } from "@shared/api/client";

export type RrhhChatUser = {
  id: number;
  nombre: string;
  correo: string;
  rol: string;
  ultimo: string;
  ultimo_en: string | null;
  unread_count: number;
};

export type RrhhChatAttachment = {
  id: number;
  nombre: string;
  mime?: string | null;
  size?: number | null;
};

export type RrhhChatMessage = {
  id: number;
  client_id?: string;
  client_order?: number;
  from: "me" | "other";
  emisor_id: number;
  mensaje: string;
  creado_en: string;
  leido: boolean;
  adjunto: RrhhChatAttachment | null;
  status?: "sending" | "sent" | "error";
};

export async function getRrhhChatUsers(): Promise<RrhhChatUser[]> {
  const { data } = await api.get<RrhhChatUser[]>("/rrhh/chat/users");
  return data;
}

export async function getRrhhChatMessages(
  adminId: number,
): Promise<RrhhChatMessage[]> {
  const { data } = await api.get<RrhhChatMessage[]>(
    `/rrhh/chat/messages/${adminId}`,
  );

  return data.map((msg) => ({
    ...msg,
    status: "sent",
  }));
}

export async function sendRrhhChatMessage(
  adminId: number,
  message: string,
  clientId: string,
  archivo?: File | null,
): Promise<RrhhChatMessage> {
  const fd = new FormData();

  fd.append("admin_id", String(adminId));
  fd.append("client_id", clientId);

  if (message.trim()) {
    fd.append("message", message);
  }

  if (archivo) {
    fd.append("archivo", archivo);
  }

  const { data } = await api.post<{
    ok: boolean;
    client_id: string | null;
    message: RrhhChatMessage;
  }>("/rrhh/chat/send", fd, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return {
    ...data.message,
    client_id: data.client_id ?? clientId,
    status: "sent",
  };
}

export async function markRrhhChatAsRead(adminId: number): Promise<void> {
  await api.post(`/rrhh/chat/read/${adminId}`);
}

export async function loadRrhhChatAttachmentPreview(
  id: number,
): Promise<Blob> {
  const res = await api.get(`/rrhh/chat/attachments/${id}/download`, {
    params: { inline: 1 },
    responseType: "blob",
  });

  return res.data as Blob;
}

export async function downloadRrhhChatAttachment(id: number): Promise<void> {
  const res = await api.get(`/rrhh/chat/attachments/${id}/download`, {
    responseType: "blob",
  });

  const blob = res.data as Blob;
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = `adjunto-${id}`;
  document.body.appendChild(a);
  a.click();

  a.remove();
  window.URL.revokeObjectURL(url);
}
